// extracted by mini-css-extract-plugin
module.exports = {"container":"AttractionListItem_container__2QX8l","text":"AttractionListItem_text__3OJ2L"};